import { StringType } from '../../App/types';

export const getDisplayRuleKey = (screen: StringType, action: StringType): string => {
  return `${screen}_${action}`;
};
